import styled, { css } from 'styled-components';
import { ReactElement } from 'react';

interface IHoverLinkMenu {
  align?: 'left' | 'center' | 'right';
  direction?: 'top' | 'bottom';
  dropdownMenu?: ReactElement;
  isDropdownMenuPermanent?: boolean;
  menuItem: ReactElement;
  style?: { [key: string]: string };
}

export const HoverDropdownMenu = ({
  align = 'center', // when aligning center, add `position: relative` to parent wrapper to center against
  direction = 'bottom',
  dropdownMenu,
  isDropdownMenuPermanent = false,
  menuItem,
  style,
}: IHoverLinkMenu) => {
  return (
    <HoverDropdownMenu.Wrapper style={style} align={align} data-qa="menu_wrapper">
      <div data-qa="menu_item" className="menu-item">
        {menuItem}
      </div>
      <HoverDropdownMenu.DropdownMenu
        align={align}
        direction={direction}
        data-qa="dropdown_menu"
        isDropdownMenuPermanent={isDropdownMenuPermanent}
      >
        {dropdownMenu}
      </HoverDropdownMenu.DropdownMenu>
    </HoverDropdownMenu.Wrapper>
  );
};

HoverDropdownMenu.Wrapper = styled.li<{ align: IHoverLinkMenu['align'] }>`
  list-style: none;
  position: ${({ align }) => (align !== 'center' ? 'relative' : 'initial')};

  :active
    ${HoverDropdownMenu.DropdownMenu},
    :hover
    ${HoverDropdownMenu.DropdownMenu},
    :focus
    ${HoverDropdownMenu.DropdownMenu} {
    visibility: visible;
  }

  .menu-item {
    display: flex;
    :active
      ${HoverDropdownMenu.DropdownMenu},
      :focus
      ${HoverDropdownMenu.DropdownMenu},
      :hover
      ${HoverDropdownMenu.DropdownMenu},
      :hover
      + div
      ${HoverDropdownMenu.DropdownMenu} {
      visibility: visible;
    }
  }
`;

HoverDropdownMenu.DropdownMenu = styled.div<{
  align: 'left' | 'center' | 'right';
  direction: 'top' | 'bottom';
  isDropdownMenuPermanent: boolean;
}>`
  border-top: 1px solid
    ${({ theme }) =>
      theme.navigation.mainBorderColor === 'transparent' ? theme.navigation.borderColor : 'none'};
  position: absolute;
  visibility: hidden;

  :hover,
  :active,
  :focus {
    visibility: visible;
  }

  ${({ isDropdownMenuPermanent }) => {
    if (isDropdownMenuPermanent) {
      return css`
        visibility: visible;
      `;
    }
  }}
  ${({ align }) => {
    if (align === 'center') {
      return css`
        left: 50%;
        transform: translateX(-50%);
      `;
    }

    if (align === 'right') {
      return css`
        right: 0;
      `;
    }

    return css`
      left: 0;
    `;
  }};

  ${({ align, direction }) => {
    if (direction === 'top' && align !== 'center') {
      return css`
        top: 0;
        transform: translateY(-100%);
      `;
    }
    if (direction === 'top' && align === 'center') {
      return css`
        top: 0;
        transform: translateX(-50%) translateY(-100%);
      `;
    }
  }};
`;
